/**
 * Creates the private content wrapper a plugin appends into the shared [data-panel] — the child
 * element it writes its own content into instead of touching [data-panel]'s innerHTML directly,
 * so leaving the view only ever removes this one element and never disturbs whatever a sibling
 * plugin has rendered there (see FLOOR_PLAN_DETAIL_PLUGIN_SEQUENCE.md /
 * HOUSING_UNIT_DETAIL_PLUGIN_SEQUENCE.md's Implementation Notes). Matches
 * listView.plugin.js's own pattern of delegating each panel child's creation to a component
 * factory (createListingHeader(), createListingContent()) — appending/removing it is still the
 * caller's job, this only owns the element itself.
 *
 * @module nativeInteractiveSiteMap/components/panelContent.dom
 */

const PANEL_CONTENT_CLASS = 'nhs-c-native-interactive-site-map-panel__content';

/**
 * @returns {{ getElement: Function, remove: Function }}
 */
export default function createPanelContent() {
  const element = document.createElement('div');
  element.className = PANEL_CONTENT_CLASS;

  return {
    getElement() {
      return element;
    },

    remove() {
      element.remove();
    },
  };
}
